module.exports = __webpack_public_path__ + "static/media/notifications.106f8448.svg";